<div class="head" (mouseenter)="onHoverContainer()" (mouseleave)="onBlurContainer()">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-11 col-9 order-lg-1 order-2">
        <div class="head__shorcuts">
          <ul>
            <li>

              <!-- <a (click)="mobileToogleMenu(false)" routerLink="/help">
                Ayuda
              </a> -->
            </li>
            <li>
              <a>
                ES
              </a>
            </li>
            <li>
              <a class="global-hand" *ngIf="userData">
                <span style="width: max-content;
                border-radius: 5px;
                text-transform: none;
                padding: 0 10px;"
                (click)="showCard()"
                #card tabindex="100" (blur)="hideCard()" (focus)="onFocus()"
                >
                  Bienvenido(a)&nbsp;&nbsp;{{userData.fullName.split(' ')[0]}}
                  <div class="relative-container">
                    <div  [ngClass]="{'global-unmount': !cardVisibility}" class="absolute-container">
                      <div
                      style="
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 25px;
                            width: 25px;
                            z-index: 101;
                            transform: translate(-14px, -10px);
                      "
                      >
                      <div style="
                        width: 100%;
                        transform: rotate(45deg);
                        height: 100%;
                        background-color: white;
                      "></div>
                    </div>
                      <div class="card-container">
                        <img style="width: 50px;
                        height: 50px;
                        background-color: skyblue;
                        border-radius: 50%;
                        align-self: flex-start;
                        margin-top: 10px;
                        margin-left: 10px;"
                        [src]="sanitizedBase64Image" alt="">

                        <div style="width: calc(100% - 50px);
                        padding: 0 0 0 10px;
                        text-align: left;
                        line-height: 20px;">
                          <b>{{userData.fullName}}</b>
                          <div style="text-transform: lowercase;">{{userData.email}}</div>
                          <span class="incard-link" style="width: max-content; text-transform: none;" (click)="goToMyProfile();">Ver perfil</span>
                          <span class="incard-link" style="
                          text-align: right;
                          width: max-content;
                          margin-left: auto;
                          margin-right: 10px;
                          text-transform: none;
                          "
                          (click)="onLogout()"
                          >Cerrar sesión</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a id="menu-toggle" (click)="mobileToogleMenu()">
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-lg-1 col-md-1 col-3 order-lg-2 order-1">
        <a class="head__logo " (click)="mobileToogleMenu(false)" routerLink="/dashboard">
          <img src="assets/img/bhp-home.png" alt="BHP">
        </a>
      </div>
      <div class="col-lg-11 col-md-12 order-3 text-align-center"
        [ngClass]="!mobileMenuShow ? 'closed-padding' : 'mobile-navbar--open' ">
        <div class="head__menu">
          <div class="table show mobile-navbar" [ngClass]="mobileMenuShow ? 'mobile-navbar--open' : ''">
            <div class="tr">
              <ng-container *ngFor="let routeDefinition of routesDefinition; index as i">
                <!-- [ngClass]="{'hide-title': !routeDefinition.show}" oculta -->
                <!-- *ngIf="routeDefinition.show" desmonta -->
                <div class=" td " *ngIf="routeDefinition.show" (mouseenter)="onHoverChild(i)"
                  (click)="onClickOptionMobile(i)">
                  <a class="head__menu__trigger global-hand"
                    style="background-image: none !important; padding-left: 5px;">
                    <b *ngIf="routeDefinition.title === 'Buscar'">
                      <img class="search-icon" src="/assets/img/icon-magnify.png">
                    </b>
                    {{routeDefinition.title}}
                    <span *ngIf="totalTaskPending && routeDefinition.title === 'Mis tareas'" style="right: auto;">
                      {{totalTaskPending}}
                    </span>
                  </a>
                  <!-- <a *ngIf="routeDefinition.title === 'Buscar'" class="head__menu__trigger">
                    {{routeDefinition.title}}
                  </a> -->
                  <ul class="show mobile-nav-option" [ngClass]="mobileShowOptions[i] ? 'mobile-nav-option--open' : ''">
                    <ng-container *ngFor="let route of routeDefinition.routes">
                      <li *ngIf="havePrivileges(route)">
                        <a (click)="mobileToogleMenu(false)" [routerLink]="route.path">
                          {{route.name}}
                        </a>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="head__blanket show animation-container" [ngClass]="show ? 'animation-container--open' : ''">
    <div>
      <div style="width: 100%; height: 20px;" [ngClass]="show ? 'show-line':'hide-line'"></div>
      <div style="width: 100%; height: 20px;"></div>
      <div *ngFor="let routeDefinition of routesDefinition; index as i" class="head__blanket__item"
        [ngClass]="hoverIndex === i ? 'head__blanket__item--active' : ''">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 offset-lg-1">
              <h3 class="head__blanket__section">
                {{routeDefinition.title}}
              </h3>
            </div>
            <div class="col-lg-7">
              <ul>
                <ng-container *ngFor="let route of routeDefinition.routes">
                  <li *ngIf="havePrivileges(route)">
                    <a (click)="mobileToogleMenu(false)" [routerLink]="route.path">
                      {{route.name}}
                    </a>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
